import React from "react";
import { Outlet } from "react-router-dom";
import Safearea from "../../components/include/Safearea";

export default function Term() {
  return (
    <Safearea>
      <Outlet />
    </Safearea>
  );
}
